var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{staticStyle:{"flex-wrap":"nowrap","z-index":"9999999"},attrs:{"type":"flex","gutter":15}},[_c('a-col',{attrs:{"flex":_vm.labelWidth}},[_c('div',{staticClass:"myformlabel",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.label))])]),_c('a-col',{attrs:{"flex":"auto"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }